/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {AreaFormComponent} from "./area-form/area-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class AreasRoutingModule {}

export const areasRoutes: any[] = [
  {
    path: editRoute + '/:id',
    component: AreaFormComponent
  },{
    path: newRoute,
    component: AreaFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/areas-routing.module.ts
 **/